import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const CardContainer = styled(Link)`
  min-width: 156px;
  margin-right: 14px;
  text-decoration: none;
  color: ${Color.gray800};

  @media (min-width: 768px) {
    min-width: 160px;
  }

  @media (min-width: 1280px) {
    min-width: 180px;
  }

  &:nth-child(1) {
    margin-left: 16px;
  }
  @media (min-width: 640px) {
    &:nth-child(1) {
      margin-left: 0;
    }
  }
`

export const Thumb = styled.div`
  position: relative;
  width: 156px;
  height: 216x;
  color: transparent;
  border-radius: 4px;
  border: 2px solid ridge;
  transition: all 0.3s ease-in-out;
  background: #f5f5f5;
  overflow: hidden;

  @media (min-width: 768px) {
    min-width: 160px;
    height: 216px;
  }

  @media (min-width: 1280px) {
    width: 180px;
    height: 270px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(205.89deg, rgba(0, 0, 0, 0) 49.81%, rgba(0, 0, 0, 0.8) 97.75%);
    z-index: 1;
  }
`

export const Image = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
  animation: fadeIn 1s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const Rating = styled.div`
  display: flex;
  position: absolute;
  left: 8px;
  bottom: 10px;
  padding: 2px 6px;
  font-weight: 700;
  background: ${({ bg }) => (bg ? bg : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)")};
  color: ${({ color }) => color};
  /* border-bottom: 0.5px solid ${({ color }) => color}; */
  /* border-top: 0.5px solid ${({ color }) => color}; */
  border-radius: 3px;
  opacity: 0.9;
  z-index: 2;

  &i {
    margin-right: 4px;
  }
`

export const Info = styled.div`
  display: none;
  ${({ isTv }) => (isTv ? "display: block;" : "display: none;")}

  @media (min-width: 640px) {
    display: block;
    margin-top: 6px;
  }
`

export const Title = styled.h4`
  font-size: 16px;
  margin-bottom: 4px;

  @media (min-width: 640px) {
    width: 100%;
    font-size: 16px;
    font-weight: medium;
    margin-bottom: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media (min-width: 1280px) {
    font-size: 18px;
  }
`

export const Date = styled.p`
  font-size: 12px;
  @media (min-width: 640px) {
    font-size: 14px;
    color: ${Color.gray600};
  }
`
